module.exports = __webpack_public_path__ + "cda01bcd3d16764d78cd9d682cb1496b.jpg";